// Modules
import { connect } from 'react-redux';
import Overlay from 'praece-react-bootstrap/lib/Overlay';
import Popover from 'praece-react-bootstrap/lib/Popover';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CheckboxInput } from 'components/forms/form-elements';
import { getOverlayContainer } from 'utils/mobile-utils';
import { preventDefault, stopPropagation } from 'utils/event-handlers';
import UserBadge from 'components/models/user/user-badge';


class TaskAssign extends React.Component {
  static propTypes = {
    assignTask: PropTypes.func.isRequired,
    task: PropTypes.object.isRequired,
    teams: PropTypes.array.isRequired,
    users: PropTypes.array
  };

  constructor() {
    super();

    this.state = { assignedTo: [], showWarning: false, showPopover: false };

    this.setAssigned = this.setAssigned.bind(this);
    this.finishAssign = this.finishAssign.bind(this);
    this.assign = this.assign.bind(this);
    this.unassign = this.unassign.bind(this);
    this.taskAssignedTo = this.taskAssignedTo.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  componentWillMount() {
    this.setState({ assignedTo: _.clone(this.props.task.assignedTo) });
  }

  componentWillReceiveProps(nextProps) {
    const taskAssignedToChanged =
        _.isEqualWith(nextProps.task.assignedTo, this.props.task.assignedTo, (nextAssigned, lastAssigned) =>
          _.isEqual(_.map(nextAssigned, 'id'), _.map(lastAssigned, 'id'))
        );

    if (!taskAssignedToChanged) {
      this.setState({ assignedTo: _.clone(nextProps.task.assignedTo) });
    }
  }

  setAssigned(id) {
    const ids = _.concat([], id);
    const assignments = _.map(this.state.assignedTo, 'id');
    const newAssignments = _.difference(ids, assignments);

    if (newAssignments.length) {
      this.assign(newAssignments);
    } else {
      this.unassign(ids);
    }
  }

  show() {
    this.setState({ showPopover: true });
  }

  hide() {
    const assignedTo = this.state.assignedTo;

    // If the task is not assigned to anyone, make sure the popover is open, show the warning,
    // and don't save the changes to the server
    if (!assignedTo.length) {
      this.setState({ showWarning: true, showPopover: true });
    } else {
      // this.props.assignTask(this.state.assignedTo);
      this.setState({ showPopover: false });
    }
  }

  assign(id) {
    const ids = _.concat([], id);
    const assignedTo = _.concat(this.state.assignedTo, _.map(ids, i => ({ id: i })));

    this.setState({ assignedTo, showWarning: false });
    this.finishAssign(assignedTo);
  }

  unassign(id) {
    const ids = _.concat([], id);
    const assignments = _.map(this.state.assignedTo, 'id');
    const difference = _.difference(assignments, ids);
    const assignedTo = _.map(difference, i => ({ id: i }));

    this.setState({ assignedTo });
    if (assignedTo.length) this.finishAssign(assignedTo);
  }

  finishAssign(ids) {
    const { assignTask, users } = this.props;

    assignTask(_.intersectionBy(users, ids, 'id'));
  }

  taskAssignedTo(id) {
    const ids = _.concat([], id);
    const assignments = _.map(this.state.assignedTo, 'id');

    return _.intersection(ids, assignments).length === ids.length;
  }

  render() {
    const { assignedTo, showWarning, showPopover } = this.state;
    const { teams } = this.props;
    const teamMap = _.keyBy(teams, 'id');
    const assignedToOrdered = _.sortBy(assignedTo, [person => teamMap[_.get(person, 'team.id', person.team)].order, 'role', 'firstName']);

    return (
      <div className="assigned-to-wrapper">
        <div className="assigned-to" onClick={stopPropagation(preventDefault(this.show))}>
          {_.map(assignedToOrdered, (user) =>
            <UserBadge key={user.id} user={user} team={_.find(teams, { id: user.team })} />)
          }
        </div>
        <Overlay
          placement="bottom"
          rootClose
          onHide={this.hide}
          target={this}
          container={getOverlayContainer}
          show={showPopover}
        >
          <Popover
            id="assign-window"
            title="Assign Users"
            onClick={stopPropagation()}
            onMouseOver={stopPropagation()}
          >
            <div className="flex flex-wrap">
              {_.map(teams, (team) => {
                const sortedTeam = _.sortBy(team.members, ['role', 'firstName']);
                const teamIds = _.map(team.members, 'id');

                return (
                  <div key={team.id || 'no-team'} className="assign-team-wrapper">
                    { team.name &&
                      <div className="team-name" style={{ borderBottom: `3px solid ${team.color}` }}>
                        <CheckboxInput
                          input={{ value: this.taskAssignedTo(teamIds), onChange: () => this.setAssigned(teamIds) }}
                          label={team.name}
                        />
                      </div>
                    }
                    <ul>
                      {_.map(sortedTeam, (user) =>
                        <li key={user.id}>
                          <CheckboxInput
                            input={{ value: this.taskAssignedTo(user.id), onChange: () => this.setAssigned(user.id), name: user.id }}
                            label={`${user.firstName} ${_.head(user.lastName)}.`}
                          />
                        </li>
                      )}
                    </ul>
                  </div>
                );
              })}
            </div>
            { showWarning && <div className="invalid-alert">Assign at least one person!</div> }
          </Popover>
        </Overlay>
      </div>
    );
  }
}

export default connect((state) => ({ users: state.pageData.selectUsers }))(TaskAssign);



// WEBPACK FOOTER //
// ./app/components/widgets/overlays/task-assign.js